export default class CalendarEvent {
    constructor(data) {
        this.data = {};
        this.data = data;
    }
    get id() {
        return this.data.id;
    }
    set id(id) {
        this.data.id = id;
    }
    get contactId() {
        return this.data.contactId;
    }
    get notes() {
        return this.data.notes;
    }
    get name() {
        return this.data.name || this.data.calendarProviderName;
    }
    get calendarId() {
        return this.data.calendarId;
    }
    get assignedUserId() {
        return this.data.assignedUserId || this.data.user_id;
    }
    get users() {
        return this.data.users || [];
    }
    get title() {
        return this.data.title;
    }
    get startTime() {
        return this.data.startTime;
    }
    get endTime() {
        return this.data.endTime;
    }
    get selectedTimezone() {
        return this.data.selectedTimezone;
    }
    get appointmentStatus() {
        return this.data.appoinmentStatus;
    }
    set appointmentStatus(appoinmentStatus) {
        this.data.appoinmentStatus = appoinmentStatus;
    }
    get address() {
        return this.data.address;
    }
    get isV3() {
        return this.data.version === 3;
    }
    get source() {
        var _a;
        return (_a = this.data.createdBy) === null || _a === void 0 ? void 0 : _a.source;
    }
    get bookedBy() {
        var _a;
        return (_a = this.data.createdBy) === null || _a === void 0 ? void 0 : _a.userId;
    }
    get recurrenceId() {
        var _a;
        return (_a = this.data) === null || _a === void 0 ? void 0 : _a.recurrenceId;
    }
    get recurringDetails() {
        var _a;
        return (_a = this.data) === null || _a === void 0 ? void 0 : _a.recurring;
    }
    get eventType() {
        var _a, _b, _c, _d;
        if (!this.data.local) {
            if ((_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.google) === null || _b === void 0 ? void 0 : _b.id) {
                return 'google';
            }
            else if ((_d = (_c = this.data) === null || _c === void 0 ? void 0 : _c.outlook) === null || _d === void 0 ? void 0 : _d.id) {
                return 'outlook';
            }
        }
        if (this.data.contactId) {
            return 'appt';
        }
        return 'event';
    }
    get editable() {
        return (!this.data.isRecurring &&
            !this.data.toIgnore &&
            (this.data.local || this.contactId));
    }
    get webinarId() {
        return this.data.webinarId;
    }
    set webinarId(value) {
        this.data.webinarId = value;
    }
    get guests() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!this.data.local) {
            if ((_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.google) === null || _b === void 0 ? void 0 : _b.id) {
                return (_e = (_d = (_c = this.data) === null || _c === void 0 ? void 0 : _c.google) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.attendees;
            }
            if ((_g = (_f = this.data) === null || _f === void 0 ? void 0 : _f.outlook) === null || _g === void 0 ? void 0 : _g.id) {
                return (_j = (_h = this.data) === null || _h === void 0 ? void 0 : _h.outlook) === null || _j === void 0 ? void 0 : _j.attendees;
            }
        }
        return this.data.guests;
    }
    set guests(value) {
        this.data.guests = value;
    }
    get isLocal() {
        return this.data.local;
    }
    get guestCount() {
        return this.data.guestCount;
    }
    set guestCount(value) {
        this.data.guestCount = value;
    }
    get isFullDay() {
        return this.data.isFullDay;
    }
    set isFullDay(isFullDay) {
        this.data.isFullDay = isFullDay;
    }
    get assignedResources() {
        return this.data.assignedResources;
    }
    set assignedResources(assignedResources) {
        this.data.assignedResources = assignedResources;
    }
    get isClassBookingEvent() {
        return !!this.data.webinarId;
    }
}
